import React, { useEffect, useState } from "react";
import { getData } from "utils/queries";
import { useParams } from "react-router-dom";
import CreateJourney from "../CreateJourney";

const EditJourney = () => {
  const [journey, setJourney] = useState(null);

  const { journey_id } = useParams();

  const fetchEventDetails = async (journey_id) => {
    try {
      const result = await getData(`journey/${journey_id}`, false);

      const ticketElements = result?.data?.data?.tickets?.map((e) => ({
        ...e,
        variants: e?.variants?.map((ee) => ({ ...ee, checked: true }))
      }));
      
      // const packageElements = result?.data?.data?.packages?.map((e) => ({
      //   ...e,
      //   package_name: e?.package_name, 
      //   checked: true, 
      // }));

      const packageElements = Array.from(
        new Map(
          (result?.data?.data?.packages || [])?.map((e) => [
            `${e.package_id}-${e.package_name?.trim()?.toLowerCase() || 'unknown'}`, 
            { ...e, package_name: e.package_name?.trim() || 'Unnamed Package', checked: true }
          ])
        ).values()
      );      
    
      
      const packageAddOns = result?.data?.data?.add_on?.map((e) => ({
        ...e,
        variants: e?.variants?.map((ee) => ({ ...ee, checked: true }))
      }));

      console.log("grouped elements",packageElements)

      const modifiedData = {
        tickets:ticketElements,
        packages: packageElements,
        addOns: packageAddOns,
      };
      console.log("modifiedData",modifiedData);
      

      setJourney({
        journey_id: result?.data?.data?.journey_id,
        journey_name: result?.data?.data?.journey_name, 
        event_name: result?.data?.data?.event_name,
        event_id: result?.data?.data?.event_id,
        journey_image: result?.data?.data?.journey_image,
        description: result?.data?.data?.description, // Add description field
        ...modifiedData
      });
      
    } catch (error) {}
  };

  useEffect(() => {
    if (journey_id) {
      fetchEventDetails(journey_id);
    }
  }, [journey_id]);

  console.log("journey",journey)

  return journey?.journey_id && <CreateJourney journey_id={journey_id} data={journey} />;
};

export default EditJourney;
